<template>
  <v-toolbar>
    <h1 @click="goTop">点数計算ドリル</h1>
  </v-toolbar>
</template>

<script>
export default {
  name: "NavHeader",
  data() {
    return {};
  },
  methods: {
    goTop() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss">
// header {
//   margin-bottom: 20px;
// }
</style>
